import {Injectable} from "@angular/core";
import {HandlerError, HttpErrorHandlerService} from "../../../core/services/http-error-handler.service";
import {HttpClient} from "@angular/common/http";
import {NovoAtendimento} from "../models/novo-atendimento";
import {catchError, Observable} from "rxjs";
import {BaseResponse} from "../../../core/models/base-response";
import {ItemAtendimento, ListaAtendimento} from "../models/lista-atendimento";
import {DetalhesAtendimento} from "../models/detalhes-atendimento";
import {AtendimentoDashboardCrm} from "../models/atendimento-dashboard-crm";
import {AtendimentoDetalhes} from "../../../core/models/atendimento-detalhes";
import {AlterarStatusAgendamento} from "../../../core/models/alterar-status-agendamento";
import {environment} from "@env/environment";
import {FunilEtapa} from "../models/funil-etapa";


@Injectable({
  providedIn: 'root'
})
export class AtendimentoService {
  private handlerErro: HandlerError;

  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandlerService) {
    this.handlerErro = httpErrorHandler.createHandleError(`AtendimentoService`);
  }

  baseUrl = environment.apiUrl;

  selecionarLista(): Observable<BaseResponse<ListaAtendimento> | BaseResponse<any>> {
    return this.http
      .get<BaseResponse<ListaAtendimento>>(`${this.baseUrl}/Atendimento`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionar')))
  }

  selecionarPorId(id: number): Observable<BaseResponse<DetalhesAtendimento> | BaseResponse<any> >{
    return this.http
      .get<BaseResponse<DetalhesAtendimento>>(`${this.baseUrl}/Atendimento/${id}`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionarPorId')));
  }

  selecionarDetalhesPorId(id: number): Observable<BaseResponse<AtendimentoDetalhes> | BaseResponse<any> >{
    return this.http
      .get<BaseResponse<AtendimentoDetalhes>>(`${this.baseUrl}/Atendimento/Detalhes/${id}`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionarDetalhesPorId')));
  }


  selecionarPorPessoaId(id: number): Observable<BaseResponse<DetalhesAtendimento> | BaseResponse<any> >{
    return this.http
      .get<BaseResponse<DetalhesAtendimento>>(`${this.baseUrl}/Atendimento/SelecionarPorPessoaId/${id}`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionarPorPessoaId')));
  }

  adicionar(request: NovoAtendimento): Observable<BaseResponse<boolean> | BaseResponse<any>> {
    return this.http
      .post<BaseResponse<boolean>>(`${this.baseUrl}/Atendimento`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>(`adicionar`)));
  }

  alterar(request: DetalhesAtendimento): Observable<BaseResponse<boolean> | BaseResponse<any>> {
    return this.http
      .put<BaseResponse<boolean>>(`${this.baseUrl}/Atendimento`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>(`alterar`)));
  }

  alterarStatus(request: AlterarStatusAgendamento): Observable<BaseResponse<boolean> | BaseResponse<any>> {
    return this.http
      .put<BaseResponse<boolean>>(`${this.baseUrl}/Atendimento/AlterarStatus`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>(`alterarStatus`)));
  }

  selecionarDashboardCRM(): Observable<BaseResponse<AtendimentoDashboardCrm[]> | BaseResponse<any> >{
    return this.http
      .get<BaseResponse<AtendimentoDashboardCrm[]>>(`${this.baseUrl}/Atendimento/ListarDashboardCRM`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionarPorId')));
  }

  selecionarPorStatus(status: number): Observable<BaseResponse<ItemAtendimento[]> | BaseResponse<any> >{
    return this.http
      .get<BaseResponse<AtendimentoDashboardCrm[]>>(`${this.baseUrl}/Atendimento/BuscarPorStatus/${status}`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionarPorStatus')));
  }

  selecionarFunil(): Observable<BaseResponse<FunilEtapa[]> | BaseResponse<any>> {
    return this.http
      .get<BaseResponse<FunilEtapa[]>>(`${this.baseUrl}/FunilCrm`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionarFunil')));
  }

  salvarFunil(etapas: FunilEtapa[]): Observable<BaseResponse<FunilEtapa[]> | BaseResponse<any>> {
    const request = etapas.map(({atendimentos, total, ...etapa}, ordem) => ({...etapa, ordem}));
    return this.http
      .put<BaseResponse<FunilEtapa[]>>(`${this.baseUrl}/FunilCrm`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('salvarFunil')));
  }

  selecionarPorUsuarioLogado(): Observable<BaseResponse<ItemAtendimento[]> | BaseResponse<any> >{
    return this.http
      .get<BaseResponse<AtendimentoDashboardCrm[]>>(`${this.baseUrl}/Atendimento/BuscarPorUsuarioLogado`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionarPorUsuarioLogado')));
  }

  uploadArquivo(atendimentoId: number, arquivo: File, origem: string = '', caminho: string = ''): Observable<BaseResponse<boolean> | BaseResponse<any>> {
    const formData = new FormData();
    formData.append('Arquivo', arquivo, arquivo.name);

    let url = `${this.baseUrl}/Atendimento/UploadArquivo?AtendimentoId=${encodeURIComponent(atendimentoId)}`;
    if (origem) {
      url += `&Origem=${encodeURIComponent(origem)}`;
    }
    if (caminho) {
      url += `&Caminho=${encodeURIComponent(caminho)}`;
    }

    return this.http
      .post<BaseResponse<boolean>>(url, formData)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('uploadArquivo')));
  }
}
